import ask from '@/utils/http'

export default {
  // 获取设备信息
  getDevice: (params = {}) => ask.get(`/backstage/device`, params),
}



// WEBPACK FOOTER //
// ./src/api/device.js